<template>
  <DataTable
    :loading="!header"
    :value="dataArray"
    responsiveLayout="scroll"
    class="p-datatable-sm editable-cells-table"
    :rowClass="hideRow"
  >
    <Column>
      <template #header="">
        <Button
          label=""
          icon="pi pi-plus"
          class="p-button-primary p-mr-2 p-button-sm"
          @click="addDetail"
          :disabled="!canEdit"
        />
      </template>
      <template #body="slotProps">
        <Button
          icon="pi pi-minus"
          class="p-button-danger p-mr-2 p-button-sm"
          @click="deleteDetail(slotProps)"
          :disabled="!canEdit"
        />
      </template>
    </Column>
    <Column field="ToolId" :header="$t('name')" key="ToolId">
      <template #body="slotProps">
        <CustomSelect
          v-model="slotProps.data[slotProps.column.props.field]"
          :url="$API_URL + 'list/permit_tools'"
          :minLength="0"
          :filter="true"
          @change="onCellEditComplete(slotProps)"
          :disabled="!canEdit"
          :params="{
            companyCode: this.companyCode,
            lang: this.getLang,
            category: header.Category,
          }"
        />
      </template>
    </Column>
    <Column field="Qty" :header="$t('qty')" key="Qty">
      <template #body="slotProps">
        <InputNumber
          name="Qty"
          v-model="slotProps.data[slotProps.column.props.field]"
          :placeholder="$t('qty')"
          :disabled="
            mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT
          "
          @blur="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column field="Condition" :header="$t('condition')" key="Condition">
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column field="Remark" :header="$t('remark')" key="Remark">
      <template #body="slotProps">
        <InputText
          name="Remark"
          v-model="slotProps.data[slotProps.column.props.field]"
          type="text"
          :placeholder="$t('remark')"
          :disabled="
            mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT
          "
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
  </DataTable>
</template>
<script>
export default {
  props: {
    dataArray: {
      type: Array,
      default: [],
    },
    dataModel: {
      type: Object,
      default: [],
    },
    mode: {
      type: String,
      default: "",
    },
    header: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      companyCode: this.$store.getters.getCompanyCode,
      getLang: this.$store.getters.getLanguage,
    };
  },
  methods: {
    hideRow(data) {
      return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
    },
    addDetail() {
      var newDetail = this.dataModel;
      newDetail.mode = this.$FORM_MODE_CREATE;
      var det = { ...newDetail };

      this.dataArray.push(det);
    },
    deleteDetail(event) {
      if (event) {
        var detail = this.dataArray[event.index];

        if (detail.mode == this.$FORM_MODE_CREATE)
          this.dataArray.splice(this.dataArray.indexOf(detail), 1);
        else detail.mode = this.$FORM_MODE_DELETE;
      }
    },
    onCellEditComplete(event) {
      this.editDetail(event.index);
    },
    editDetail(index) {
      if (this.dataArray && this.dataArray.length > 0) {
        let m = this.dataArray[index].mode;

        if (m == this.$FORM_MODE_UNCHANGED) {
          this.dataArray[index].mode = this.$FORM_MODE_EDIT;
        }
      }
    },
    changever(event, e) {
      if (this.dataArray && this.dataArray.length > 0) {
        this.dataArray[event.index].Version = e == null ? "1" : e.id;
      }
    },
  },
  computed: {
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
  },
};
</script>
